import {IMAGE_DEFAULT_FORMATS} from "../../../../../core/app/consts";
import {AssetsRequestParams} from "../../../../../infrastructure/models/params/assets-request-params";

export class LegalImageRequestParams extends AssetsRequestParams {
  constructor(id: String, width: Number, height: Number) {
    super(width, height);

    this.resourceName = `${this.resourceName}/Legal/${id}`;
    this.id = id;
    this.version = 3;
    this.ratio = 3;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}
